import {StudentProgressReportService} from '@esgi/main/features/teacher/student-progress-report';
import {ReportModal, ReportModalHeader} from '@esgi/deprecated/ui-kit/report/modal';
import {SettingsModalHeader} from './components/modal-header';
import StudentsTable from './components/table';
import {ServiceLoader} from '@esgi/ui-kit/loader';
import {useModal} from '@esgi/ui-kit/modal';
import {useBehaviorSubject} from '@esgi/ui-kit/utils';
import {
	Report,
} from '@esgi/contracts/esgi/types/esgi.reports/endpoints/esgi.apigateway/student-progress-report/models/report';
import {useEffect} from 'react';
import {GoogleAnalyticsTracker} from '@esgi/core/tracker';
import {
	ReportModlaBodyStyled,
	StudentProgressReportContainer,
	StudentProgressReportWrapper,
} from './index.styled';

type Props = {
	onClose: VoidFunction;
	service: StudentProgressReportService;
};

export function PreviewDialog(props: Props) {
	const modalManager = useModal();
	const report = useBehaviorSubject<Report>(props.service.report$);

	const onClose = () => {
		modalManager.current.close();
		props.onClose();
	};

	useEffect(() => {
		GoogleAnalyticsTracker.trackEvent('StudentProgressReport');
	}, []);

	return <ReportModal modalManagerRef={modalManager}>
		<ReportModalHeader>
			<SettingsModalHeader service={props.service} onClose={onClose} />
		</ReportModalHeader>
		<ReportModlaBodyStyled>
			<StudentProgressReportWrapper data-cy='spr-container'>
				<StudentProgressReportContainer>
					{
						report !== null && <StudentsTable service={props.service}/>
					}
				</StudentProgressReportContainer>
			</StudentProgressReportWrapper>
			<ServiceLoader trackingService={props.service} fullscreen/>
		</ReportModlaBodyStyled>
	</ReportModal>;
}
